import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const API_BASE = "https://eluvent.com/api";

const Teacher = () => {
  const [sessions, setSessions] = useState([]);
  const [pin, setPin] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const authenticate = () => {
    if (pin === "2026") {  // same simple PIN as admin
      setAuthenticated(true);
      fetchSessions();
    } else {
      alert("Invalid PIN");
    }
  };

  const fetchSessions = async () => {
    try {
      const res = await fetch(`${API_BASE}/teacher/sessions`);
      const data = await res.json();
      setSessions(data);
    } catch (err) {
      console.error("Failed to fetch sessions", err);
    }
  };

  if (!authenticated) {
    return (
      <div style={{ maxWidth: "400px", margin: "100px auto", textAlign: "center", fontFamily: "Nunito, sans-serif" }}>
        <h2>👨‍🏫 Teacher Login</h2>
        <input
          type="password"
          placeholder="Enter PIN"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          style={{ padding: "12px", borderRadius: 12, border: "2px solid #e2e8f0", width: "100%", marginBottom: 12, fontSize: "14px" }}
        />
        <button onClick={authenticate} style={{ width: "100%", padding: "12px", background: "#fca311", color: "white", border: "none", borderRadius: 30, fontWeight: "700", fontSize: "14px", cursor: "pointer" }}>
          🔓 Unlock Dashboard
        </button>
        <Link to="/" style={{ display: "block", marginTop: 12, color: "#64748b", textDecoration: "none" }}>← Back to Home</Link>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", fontFamily: "Nunito, sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#1e293b" }}>👨‍🏫 Teacher Dashboard</h1>
      <div style={{ background: "white", borderRadius: 20, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.04)", marginBottom: 20 }}>
        <h3 style={{ margin: "0 0 12px", color: "#fca311" }}>📅 Upcoming Sessions</h3>
        {sessions.length === 0 && <p style={{ color: "#94a3b8" }}>No upcoming sessions.</p>}
        {sessions.map(s => (
          <div key={s.id} style={{ padding: "12px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <p style={{ fontWeight: "600", margin: 0 }}>{s.student_name}</p>
              <p style={{ fontSize: "12px", color: "#64748b", margin: "4px 0 0" }}>{s.subject} | {s.date}</p>
            </div>
            <a href={`mailto:${s.student_email}`} style={{ color: "#fca311", textDecoration: "none", fontWeight: "600", fontSize: "13px" }}>📧 Contact</a>
          </div>
        ))}
      </div>
      <Link to="/" style={{ color: "#64748b", textDecoration: "none" }}>← Back to Home</Link>
    </div>
  );
};

export default Teacher;